import React from 'react';
import './pagefooter.css';
import { Helmet } from 'react-helmet-async';

const Terms = () => (
  <>
    <Helmet>
      <title>Terms & Conditions | Aikyam Sports Science</title>

      <meta
        name="description"
        content="Read the terms and conditions of Aikyam Sports Science covering our sports science services, timing gates, fitness solutions, and website usage."
      />

      <meta
        name="keywords"
        content="Aikyam Sports Science terms, sports science services terms, timing gates terms and conditions, Udupi sports training"
      />

      <meta
        property="og:title"
        content="Terms & Conditions | Aikyam Sports Science"
      />

      <meta
        property="og:description"
        content="Terms and conditions for using Aikyam Sports Science products and services."
      />

      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://aikyamsports.com/terms"
      />
      <link
        rel="canonical"
        href="https://aikyamsports.com/terms"
      />
    </Helmet>
    <div className="policy-page">
      <h1>Terms & Conditions</h1>
      <p>Welcome to Aikyam Sports Science. By accessing or using our website and services, you agree to be bound by the following terms and conditions. Please read them carefully.</p>
      <ul>
        <li><strong>Services:</strong> We provide timing gate products and fitness services, including athlete monitoring, injury prevention, and performance analysis.</li>
        <li><strong>Product Use:</strong> Our timing gates are designed for speed and jump assessments, and should be used as per the provided instructions.</li>
        <li><strong>Intellectual Property:</strong> All content, logos, and product designs are the property of Aikyam Sports Science and may not be used without permission.</li>
        <li><strong>Limitation of Liability:</strong> We are not liable for any injuries or damages resulting from misuse of our products or services.</li>
        <li><strong>Changes to Terms:</strong> We reserve the right to update these terms at any time. Continued use of our services constitutes acceptance of the new terms.</li>
        <li><strong>Contact:</strong> For any questions, please contact us at +916363202281 or +917019386664.</li>
      </ul>
      <p>Location: Center for Sports Science, Mahatma Gandhi Stadium, Ajjarakad, Brahmagiri, Udupi, Karnataka - 576101</p>
    </div>
  </>
);

export default Terms;
